import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
  statusChip: {
    cursor: 'pointer'
  },
  chipSuccess: {
    backgroundColor: theme.palette.success.light
  },
  chipError: {
    backgroundColor: theme.palette.error.light
  },
  drawer: {
    backgroundColor: '#F0F3F7',
    [theme.breakpoints.down('xs')]: { width: '100%' },
    [theme.breakpoints.up('sm')]: { width: '90%' },
    [theme.breakpoints.up('md')]: { width: '75%' },
    [theme.breakpoints.up('lg')]: { width: '60%' },
    [theme.breakpoints.up('xl')]: { width: '50%' },
    padding: '0 30px'
  },
  drawerToolbar: {
    padding: '10px 5px'
  }
}))
